var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:_vm.thClass,attrs:{"scope":"col"}},[_c('v-text-field',_vm._g(_vm._b({staticClass:"pa-1",attrs:{"hide-details":"","dense":"","solo":"","clearable":"","placeholder":"Rechercher","prepend-inner-icon":_vm.icon ? 'mdi-magnify' : null,"label":_vm.labelValue}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }